<template>
  <v-container fluid>
    <v-layout>
      <v-flex xs12 sm6 offset-sm3>
        <div class="my-4 display-1">Android aplikacija</div>
        <div class="headline">Trenutna verzija aplikacije {{appVersion}}</div>
        <div v-if="configuration.android.forceUpdate" class="headline">Neophodno je instalirati novu verziju aplikacije</div>
        <v-btn class="my-5" :href="configuration.android.applicationUrl" large block outline>preuzmi</v-btn>
        <!-- <a href='https://play.google.com/store/apps/details?id=rs.lanser&ah=PLuMtEJuWvFHXmR3B34kr1KVSH8&rdid=rs.lanser&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'>
          <img alt='Набавите на Google Play' src='https://play.google.com/intl/en_us/badges/images/generic/sr_badge_web_generic.png'/>
        </a> -->
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

import configurationService from '@/services/configurationService'

const appVersion = process.env.VERSION

export default {
  data () {
    return {
      configuration: configurationService.getConfiguration(),
      appVersion: appVersion
    }
  }
}

</script>

<style scoped>

</style>
